const COLORS = {
    blue: '#0F789B',
    green: '#AAB414',
    orange: '#F58C14',
    teal: '#41AAAA',
    purple: '#AF235F'
}

export default class AnimatedFigure {
    defaults () {
        return {
            timeline: new TimelineMax,
            delay: 0,
            interval: 0,
            duration: 1,
            animation: 'stroke',
            count: 0,
            color: ''
        }
    }

    constructor(element, options = {}) {
        this.el = element
        Object.assign(this, this.defaults(), options)
        this.init()
    }

    init() {
        const svg = this.el.contentDocument.documentElement
        this.paths = svg.querySelectorAll('path')
        svg.style.color = COLORS[this.color]
        TweenLite.to(this.paths, 0, { drawSVG: 0 })
        this.el.classList.add('visible')
    }

    run () {

        TweenLite.to(this.paths, 0, { drawSVG: 0 })

        return this.timeline

            .delay(this.delay)
            .to(this.paths, this.duration/2, { drawSVG: '0 100%' })
            .to(this.paths, this.duration/2, { drawSVG: '100% 100%' })
            // .to(this.paths, 0, { drawSVG: 0 })
            // .fromTo(this.paths, this.duration, { drawSVG: '0' }, { drawSVG: '100%' })
            // .fromTo(this.paths, this.duration, { drawSVG: '0 100%' }, { drawSVG: '100% 100%' })
            .repeatDelay(this.interval)
            .repeat(this.count)

        // if(this.delay) {
        //     setTimeout(() => transition(), Number(this.delay) * 1000)
        // } else {
        //     transition()
        // }
    }

    go () {
        this.run().add(() => {
            this.timeline.clear()
        })
    }
}
